<div class="upload-content"
     [class.upload-content--compact]="compactLayout && !figmaDropzoneLayout"
     [class.upload-content--figma-dropzone]="figmaDropzoneLayout">
  <div>
    <ng-container *ngIf="!selectedImage && !selectedPdf && !uploadedFile && !selectedExcel && !isConsult">
      <div class="upload-file-empty"
           [class.upload-file-empty--compact]="compactLayout && !figmaDropzoneLayout">
        <input type="file"
               hidden
               #fileDropRef
               (change)="handleFileSelect($event)"
               multiple />
        <i class="mdi mdi-cloud-upload"></i>
        <p *ngIf="!dragged; else notifyLoading">
          <ng-container *ngIf="uploadPromptPrefix && !figmaDropzoneLayout">
            {{ uploadPromptPrefix }}
          </ng-container>
          <button type="button"
                  class="btn p-0"
                  [class.text-primary]="!figmaDropzoneLayout"
                  [class.upload-file-empty__figma-link]="figmaDropzoneLayout"
                  (click)="fileDropRef.click()"
                  [disabled]="isExhibition">
            {{ uploadButtonText }}
          </button>
          <small *ngIf="!figmaDropzoneLayout"
                 [class.d-block]="!compactLayout"
                 [class.upload-file-empty__formats]="compactLayout">{{ allowedFormatsLabel }} {{ getAllowedFormats }}</small>
          <span class="text-danger d-block"
                *ngIf="showInvalidFileFormat">Formato selecionado inválido.</span>
          <span class="text-danger d-block"
                *ngIf="showFileSizeExceededError">O arquivo selecionado é muito grande. tamanho máximo aceito é
            {{ fileSizeLimit | kbToMb }} e o tamanho do arquivo é
            {{ this.currentFile.size | kbToMb }}</span>
          <span class="text-danger d-block"
                *ngIf="showExceededFileLimit">O número máximo de {{ maxFiles }} arquivos foi excedido.</span>
        </p>
        <ng-template #notifyLoading>
          <p #notifyLoading>processando imagem...</p>
        </ng-template>
      </div>
    </ng-container>

    <!-- {{aaa}} -->
    <div class="position-relative p-2"
         *ngIf="
        (selectedImage || selectedPdf || selectedExcel || uploadedFile) &&
        (selectedImage !== undefined ||
          selectedPdf !== undefined ||
          selectedExcel !== undefined ||
          uploadedFile !== undefined)
      ">
      <img class="img-upload"
           *ngIf="selectedImage && isImagePreview"
           [src]="selectedImage"
           alt="Imagem carregada"
           (click)="openModal()"
           (error)="errorHandler()" />

      <div class="pdf"
           *ngIf="selectedPdf && isPdfPreview">
        <img src="../../../../assets/images/pdf-logo.png"
             [alt]="fileName" /><br />
        <span class="my-2">{{ fileName }}</span>
      </div>

      <div class="pdf"
           *ngIf="selectedExcel">
        <img src="../../../../assets/images/excel-logo.png"
             [alt]="fileName" /><br />
        <span class="my-2">{{ fileName }}</span>
      </div>

      <div class="pdf cursor-default"
           *ngIf="(uploadedFile || isGenericFilePreview) && !selectedExcel && !(selectedPdf && isPdfPreview) && !(selectedImage && isImagePreview)">
        <img src="../../../../assets/images/icon_arquivo.png"
             width="80px"
             [alt]="fileName" /><br />
        <span class="my-2">{{ fileName || fileTypeLabel }}</span>
      </div>

      <button *ngIf="permiteRemover === true && !isConsult"
              class="btn btn-outline-danger position-absolute delete-button"
              (click)="removeFile()">
        <i class="mdi mdi-delete-outline"></i>
      </button>
    </div>
    <!-- Modal para exibir a imagem -->

    <app-new-modal [modalOpen]="showModal"
                   (closeModalEvent)="closeModal()">
      <div class="pdf-content"
           (keydown)="onKeyDown($event)">
        <img class="expanded-image"
             *ngIf="selectedImage && isImagePreview"
             [src]="selectedImage"
             alt="Imagem carregada" />
        <app-new-modal [modalOpen]="showModal"
                       (closeModalEvent)="closeModal()">
          <div class="pdf-content"
               (keydown)="onKeyDown($event)">
            <img class="expanded-image"
                 *ngIf="selectedImage && isImagePreview"
                 [src]="selectedImage"
                 alt="Imagem carregada" />
          </div>
        </app-new-modal>
      </div>
    </app-new-modal>
  </div>
</div>